import { render, staticRenderFns } from "./pdf-viewer.vue?vue&type=template&id=307535b8&scoped=true&"
import script from "./pdf-viewer.vue?vue&type=script&lang=js&"
export * from "./pdf-viewer.vue?vue&type=script&lang=js&"
import style0 from "./pdf-viewer.vue?vue&type=style&index=0&id=307535b8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "307535b8",
  null
  
)

export default component.exports